import n from "./internal/_curry2.mjs";
import e from "./internal/_isFunction.mjs";
import a from "./curryN.mjs";
import i from "./toString.mjs";
var l = /* @__PURE__ */ n(function(o, t) {
  return a(o + 1, function() {
    var r = arguments[o];
    if (r != null && e(r[t]))
      return r[t].apply(r, Array.prototype.slice.call(arguments, 0, o));
    throw new TypeError(i(r) + ' does not have a method named "' + t + '"');
  });
});
export {
  l as default
};
